import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    root: {
      width: '100%',
      margin: '80px auto',
    },
    rootSmaller: {
      width: '100%',
      margin: '0px auto',
    },
    button: {
      width: '100%',
    },
    yellow: {
      color: palette.deepBlue,
    },
    green: {
      color: palette.navAdmin,
    },
    gray: {
      color: palette.navSuperAdmin,
    },
    blue: {
      color: palette.navOperator,
    },
  });
